import React, {useState} from "react";
import CustomDialog from "../../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../../core/components/common/custom-dialog-loader.component"
import useGatePassConfiguration from "../../hooks/useGatePassConfiguration";
import CustomTypography from "../../../../core/components/ui/CustomTypography";
import CustomTextField from "../../../../core/components/ui/CustomTextfield";
import EntryTypeDropdownComponent from "../../../GatePassPlugin/common/entry-type-dropdown.component";
import PassTypeDropdownComponent from "../../../GatePassPlugin/common/pass-type-dropdown.component";


const AddGatePassConfigurationDialog = (props) => {
    const {open, setOpen, selectedRole} = props;

    const {isAddingGatePassConfiguration, createProfileGatePassConfiguration} = useGatePassConfiguration();

    const [selectedEntryType, setSelectedEntryType] = useState(null);
    const [selectedPassType, setSelectedPassType] = useState(null);


    const handleEntryTypeChange = (value) => {
        setSelectedEntryType(value);
    }

    const handlePassTypeChange = (value) => {
        setSelectedPassType(value);
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedEntryType(null);
        setSelectedPassType(null);
    }

    const handleAddGatePassConfiguration = () => {
        const payload = {
            role: selectedRole,     
            entryType: selectedEntryType,
            gatepassType: selectedPassType,
        }
        
        createProfileGatePassConfiguration(payload, setOpen);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: handleClose,
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Add",
            onClick: (e) => (selectedEntryType && selectedPassType && !isAddingGatePassConfiguration) ? handleAddGatePassConfiguration(e) : null,
            customStyles: {
                opacity: (selectedEntryType && selectedPassType && !isAddingGatePassConfiguration) ? "100%" : "55%",
                cursor: (selectedEntryType && selectedPassType && !isAddingGatePassConfiguration) ? "pointer" : "not-allowed !important",
                visibility: (isAddingGatePassConfiguration) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isAddingGatePassConfiguration) ? null : handleClose}
                title="Add Gate Pass Configuration"
                subtitle={"Create gate pass configuration for profile"}
                hasDividers={true}
                content={
                    <Box>
                        {(isAddingGatePassConfiguration) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Adding profile gate pass configuration..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Role"}
                                    customStyles={{
                                        //
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={selectedRole}
                                    variant={"outlined"}
                                    value={selectedRole}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                    readOnly={true}
                                    customStyles={{
                                        mb: 2
                                    }}
                                />

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Entry Type"}
                                    customStyles={{
                                        mb: (selectedEntryType) ? 2 : 1
                                    }}
                                />

                                <EntryTypeDropdownComponent
                                    value={selectedEntryType}
                                    onChange={handleEntryTypeChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> 

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Pass Type"}
                                    customStyles={{
                                        mb: (selectedPassType) ? 2 : 1,
                                        mt: 1.5
                                    }}
                                />

                                <PassTypeDropdownComponent
                                    value={selectedPassType}
                                    onChange={handlePassTypeChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>
                            </>
                        }
                    </Box>
                }
                actions={!isAddingGatePassConfiguration && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default AddGatePassConfigurationDialog
